import {getUserInfo} from "../auth";
import {getNow, parseDate} from "../index";

/**
 * 创建、更新 添加作者相关信息
 * @type {{data(): {userInfo: {}}, watch: {open(): void}, created(): void, methods: {hello()}, mounted()}}
 */
export const mixin = {
    data() {
        return {
            userInfo: {},
            now: new Date(),
            // labelPosition: 'right',
            uploadAction: '/all-elements/api/v1/other/uploadFile',
            // headers: {
            //     token: sessionStorage.getItem("token"),
            // },
            commonButton: "primary",
            inputWidth: 200,
            tableHeight: '65vh',
            commonTableHeight: '56.5vh',
        }
    },
    created() {
        this.userInfo = getUserInfo()
        this.now = getNow()
    },
    mounted() {

    },
    methods: {
        parseDate(timeLong){
            parseDate(timeLong)
        },
        // 生成创建相关信息
        createInfo(data) {
            data.createBy = this.userInfo.name
            data.createId = this.userInfo.id
            data.createTime = this.now
            data.modifyBy = this.userInfo.name
            data.modifyId = this.userInfo.id
            data.modifyTime = this.now
        },
        modifyInfo() {
            this.form.modifyBy = this.userInfo.name
            this.form.modifyId = this.userInfo.id
            this.form.modifyTime = this.now
        },
        // 数组去除子项 用于主子表删除子项
        removeArrSon(data, delIndex) {
            return data.filter((item, index) => {
                return index != delIndex
            }).map((item) => {
                if (item.sort > delIndex) {
                    item.sort = item.sort - 1
                    return item
                }
                return item
            })
        },
        removeArrSons(data, indexArr) {
            let newData = data.filter((item, index) => {
                return !indexArr.includes(index)
            })
            return newData.map((item, index) => {
                item.sort = index
                return item
            })
        }
    },
    watch: {
        'open'() {
            if (this.form) {
                let now = getNow()
                if (this.form.id == null) {
                    this.form.createBy = this.userInfo.name
                    this.form.createId = this.userInfo.id
                    this.form.createTime = now
                    this.form.modifyBy = this.userInfo.name
                    this.form.modifyId = this.userInfo.id
                    this.form.modifyTime = now
                } else {
                    this.form.modifyBy = this.userInfo.name
                    this.form.modifyId = this.userInfo.id
                    this.form.modifyTime = now
                }
            }
        },
    },
}
